import moment from "moment"

export const formatDate = (date: string) => moment(date).format('MMMM DD, YYYY HH:mm:ss')

export const statusColors: any = {
    processing: 'warning.main',
    completed : 'success.main',
    failed    : 'error.main'
}
